(function () {
  const MAKE_LABELS = {
    ford: 'Ford',
    gm: 'GM',
    ram: 'Ram',
    jeep: 'Jeep',
    benz: 'Mercedes Benz',
    nissan: 'Nissan',
  };

  const BODY_LABELS = {
    all: 'All body styles',
    pickup: 'Pickup',
    CC: 'Cab & Chassis',
    van: 'Van',
  };

  const popup = document.getElementById('td-vehicle-popup');
  if (!popup) return;

  const dialog = popup.querySelector('.td-vehicle-popup__dialog');
  const tabs = popup.querySelectorAll('[data-vehicle-popup-tab]');
  const panels = popup.querySelectorAll('[data-vehicle-popup-panel]');
  const currentSection = popup.querySelector('[data-vehicle-popup-garage-current]');
  const clearSelectedButton = popup.querySelector('[data-vehicle-clear-selected]');
  const currentVehicleEl = popup.querySelector('[data-vehicle-popup-current-vehicle]');
  const savedSection = popup.querySelector('[data-vehicle-popup-garage-saved]');
  const garageList = popup.querySelector('[data-vehicle-popup-garage-list]');
  const emptyState = popup.querySelector('[data-vehicle-popup-garage-empty]');

  const YME_RESULTS_URL = '/pages/year-make-product-search-results';

  const TRASH_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"/><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"/></svg>';

  let lastFocusedElement = null;

  function formatEngineDisplay(engine) {
    return (
      window.TdVehicleStorage?.formatEngineDisplay(engine) ||
      String(engine || '').replace(/-/g, '.')
    );
  }

  function formatVehicleTitle(vehicle) {
    if (!vehicle) return '';

    const make = MAKE_LABELS[vehicle.make] || vehicle.make;
    const year = vehicle.year || '';
    const engine = formatEngineDisplay(vehicle.engine);

    return `${year} ${make} ${engine}`.replace(/\s+/g, ' ').trim();
  }

  function formatVehicleMeta(vehicle) {
    if (!vehicle) return '';
    return BODY_LABELS[vehicle.body] || vehicle.body || '';
  }

  function createGarageItemMarkup(vehicle, { isCurrent = false, showActions = false } = {}) {
    const title = formatVehicleTitle(vehicle);
    const meta = formatVehicleMeta(vehicle);
    const actions = showActions
      ? `<div class="td-vehicle-popup__garage-item__actions">
          <div class='action-buttons'>
            <button type="button" class="td-vehicle-popup__garage-item__select" data-vehicle-select>Select</button>
            <button type="button" class="td-vehicle-popup__garage-item__see-products" data-vehicle-see-products>See Products</button>
          </div>
          <button type="button" class="td-vehicle-popup__garage-item__delete" data-vehicle-delete aria-label="Remove ${title}">
            ${TRASH_ICON}
          </button>
        </div>`
      : '';

    return `
      <div class="td-vehicle-popup__garage-item__content">
        <p class="td-vehicle-popup__garage-item__title">${title}</p>
        ${meta ? `<p class="td-vehicle-popup__garage-item__meta">${meta}</p>` : ''}
      </div>
      ${actions}
    `;
  }

  function renderGarage() {
    const vehicles = window.TdVehicleStorage?.getSavedVehicles() || [];
    const selectedVehicle = window.TdVehicleStorage?.getSelectedVehicle() || null;
    const otherVehicles = vehicles.filter((vehicle) => vehicle.id !== selectedVehicle?.id);

    garageList.innerHTML = '';

    if (!vehicles.length) {
      currentSection.hidden = true;
      savedSection.hidden = true;
      emptyState.hidden = false;
      return;
    }

    emptyState.hidden = true;

    if (selectedVehicle) {
      currentSection.hidden = false;
      currentVehicleEl.className = 'td-vehicle-popup__garage-item is-current';
      currentVehicleEl.innerHTML = createGarageItemMarkup(selectedVehicle, { isCurrent: true });
    } else {
      currentSection.hidden = true;
    }

    if (otherVehicles.length) {
      savedSection.hidden = false;
      otherVehicles.forEach((vehicle) => {
        const item = document.createElement('div');
        item.className = 'td-vehicle-popup__garage-item';
        item.dataset.vehicleId = vehicle.id;
        item.innerHTML = createGarageItemMarkup(vehicle, { showActions: true });
        garageList.appendChild(item);
      });
    } else {
      savedSection.hidden = true;
    }
  }

  function setActiveTab(tabName) {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.vehiclePopupTab === tabName;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      const isActive = panel.dataset.vehiclePopupPanel === tabName;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });

    if (tabName === 'garage') {
      renderGarage();
    }
  }

  function open(options = {}) {
    lastFocusedElement = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    setActiveTab(options.tab || 'new');
    dialog.focus();
  }

  function close() {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');

    if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
      lastFocusedElement.focus();
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      setActiveTab(tab.dataset.vehiclePopupTab);
    });
  });

  popup.querySelectorAll('[data-vehicle-popup-close]').forEach((element) => {
    element.addEventListener('click', close);
  });

  popup.addEventListener('click', (event) => {
    if (dialog.contains(event.target)) return;
    close();
  });

  clearSelectedButton?.addEventListener('click', (event) => {
    event.preventDefault();
    window.TdVehicleStorage?.clearSelectedVehicle();
    renderGarage();
  });

  document.addEventListener('keydown', (event) => {
    if (popup.hidden) return;
    if (event.key === 'Escape') close();
  });

  garageList.addEventListener('click', (event) => {
    const selectButton = event.target.closest('[data-vehicle-select]');
    if (selectButton) {
      const item = selectButton.closest('[data-vehicle-id]');
      if (!item) return;

      window.TdVehicleStorage?.selectVehicle(item.dataset.vehicleId);
      renderGarage();
      return;
    }

    const seeProductsButton = event.target.closest('[data-vehicle-see-products]');
    if (seeProductsButton) {
      const item = seeProductsButton.closest('[data-vehicle-id]');
      if (!item) return;

      window.TdVehicleStorage?.selectVehicle(item.dataset.vehicleId);
      window.location.href = window.TdVehicleStorage?.getResultsUrl() || YME_RESULTS_URL;
      return;
    }

    const deleteButton = event.target.closest('[data-vehicle-delete]');
    if (!deleteButton) return;

    event.preventDefault();
    event.stopPropagation();

    const item = deleteButton.closest('[data-vehicle-id]');
    if (!item) return;

    window.TdVehicleStorage?.removeVehicle(item.dataset.vehicleId);
    renderGarage();
  });

  window.addEventListener('td:vehicle-storage-change', renderGarage);
  window.addEventListener('storage', (event) => {
    if (event.key === window.TdVehicleStorage?.STORAGE_KEY) {
      renderGarage();
    }
  });

  window.TdVehiclePopup = {
    open,
    close,
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-vehicle-popup-open]');
    if (!trigger) return;
    event.preventDefault();
    open({ tab: trigger.dataset.vehiclePopupTab || 'new' });
  });
})();
